interface Props {
  id?: any
  query?: string
  recent?: string | number
  filter?: any
  page?: number
  limit?: number
  thread_id?: string
  generate?: string
}

export const ManageNotifications = {
  getList: `notifications`,
  post: `notification`,
  update: (id?: number) => `notification?id=${id}`,
  delete: (id?: number) => `notification/id=${id}`
}
